import Skeleton from 'react-loading-skeleton'

export const FreightSkeleton = ({ isReverse }: { isReverse: boolean }) => {
  return (
    <div className="h-[48px] flex items-start justify-between">
      <div
        className={`flex flex-col w-[200px] ${
          isReverse ? 'flex-col-reverse' : ''
        }`}
      >
        <div className="w-[120px]">
          <Skeleton className="w-full" height={20} />
        </div>
        <Skeleton className="w-full" height={20} />
      </div>
      <div className="w-[60px]">
        <Skeleton className="w-full" height={20} />
      </div>
    </div>
  )
}
